<template>
  <div>
    <div
      style="display:flex;justify-content:space-between;align-items: center;padding:0 10px"
    >
      <el-form
        class="search-from-cla"
        :inline="true"
        :model="params"
        label-position="left"
      >
        <el-form-item prop="loginName">
          <el-input
            v-model.trim="params.loginName"
            :placeholder="this.$t('user.account')"
            :clearable="true"
          >
            <template slot="append">
              <i @click="commQuery" class="el-icon-search"></i>
            </template>
          </el-input>
        </el-form-item>
        <!-- <el-button type="primary" @click="commQuery" icon="el-icon-search">
          {{ $t('common.search') }}
        </el-button> -->
      </el-form>
      <ZkButtonGroup
        :isLoadGroupName="true"
        @addUser="addUser"
        groupName="addAdminUser"
        :isGroup="true"
      ></ZkButtonGroup>
    </div>

    <div class="black_panel_cla">
      <el-table :data="userData" style="width: 100%">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          prop="loginName"
          :label="this.$t('user.account')"
        ></el-table-column>
        <el-table-column prop="name" :label="this.$t('user.userName')">
          <template slot-scope="scope">
            {{ isEmpty(scope.row.name) }}
          </template>
        </el-table-column>
        <el-table-column prop="email" :label="this.$t('user.email')">
          <template slot-scope="scope">{{
            scope.row.email | emailFormat
          }}</template>
        </el-table-column>
        <el-table-column prop="status" :label="this.$t('user.status')">
          <template slot-scope="scope">
            <!-- <zk-dictionary-transform :value="scope.row.status"
                                     type="status"
                                     :key="scope.row.id + scope.row.status"></zk-dictionary-transform> -->
            <el-tooltip
              :content="
                scope.row.status === 1
                  ? $t('operation.freeze')
                  : $t('operation.unfreeze')
              "
              placement="bottom"
            >
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="freezeOrUnfreeze($event, scope.row)"
              ></el-switch>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column min-width="250px" :label="this.$t('common.operation')">
          <template slot-scope="scope">
            <ZkButtonGroup
              class="admin-account-cla-btnGroup"
              :key="scope.row.id + scope.row.status"
              :isLoadGroupName="true"
              @updateUser="updateUser"
              @deleteUser="deleteUser"
              @resetPassword="resetPassword"
              :event="
                scope.row.status === 1
                  ? ['updateUser', 'deleteUser', 'resetPassword']
                  : ['updateUser', 'deleteUser', 'resetPassword']
              "
              :onlyShowText="true"
              :params="scope.row"
              :showText="true"
              size="mini"
              groupName="adminUserOperation"
              :isGroup="true"
            ></ZkButtonGroup>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="changePageSize"
          @current-change="changePage"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, prev, pager, next, sizes"
          :total="pager.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :append-to-body="true"
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="formValidate"
        class="adduserFrom"
        :model="userform"
        :rules="rules"
        label-width="180px"
        label-position="right"
      >
        <el-row>
          <el-col :span="11">
            <el-form-item :label="$t('user.account')" prop="loginName">
              <el-input
                v-model.trim="userform.loginName"
                :placeholder="$t('user.inputAccount')"
                :disabled="isUpdate || idDetails"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item :label="$t('user.userName')" prop="name">
              <el-input
                :disabled="idDetails"
                v-model.trim="userform.name"
                :placeholder="$t('user.inputName')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item :label="$t('user.sex')" prop="sex">
              <zk-dictionary-select
                :disabled="idDetails"
                type="sex"
                v-model="userform.sex"
                clearable
                :placeholder="$t('common.select')"
              ></zk-dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item :label="$t('user.nickName')" prop="nickName">
              <el-input
                :disabled="idDetails"
                v-model.trim="userform.nickName"
                :placeholder="$t('user.inputNickName')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="!isUpdate && !idDetails">
          <el-col :span="11">
            <el-form-item
              :label="$t('user.password')"
              prop="password"
              v-if="!isUpdate"
            >
              <el-input
                type="password"
                :disabled="idDetails"
                v-model.trim="userform.password"
                :placeholder="$t('user.inputPwd')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item
              :label="$t('user.confirmedPwd')"
              prop="secondPwd"
              v-if="!isUpdate"
            >
              <el-input
                type="password"
                :disabled="idDetails"
                v-model.trim="userform.secondPwd"
                :placeholder="$t('user.input2ndPwd')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item :label="$t('user.email')" prop="email">
              <el-input
                :disabled="idDetails"
                v-model.trim="userform.email"
                :placeholder="$t('user.inputEmail')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item :label="$t('user.phone')" prop="phone">
              <el-input
                :disabled="idDetails"
                v-model.trim="userform.phone"
                :placeholder="$t('user.inputPhone')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item :label="$t('user.status')" prop="status">
              <zk-dictionary-select
                :disabled="idDetails"
                type="status"
                v-model="userform.status"
                :placeholder="$t('common.select')"
              ></zk-dictionary-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" @click.stop="submitSave">
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="40%"
      @close="handleClose"
    >
      <el-form
        :model="codeForm"
        label-width="120px"
        ref="codeForm"
        :rules="codeRules"
      >
        <div style="margin-bottom:15px ">
          <span v-if="isReset">
            {{
              $tc('user.confirmResetPwdTip', 1) +
                row.loginName +
                $tc('user.confirmResetPwdTip', 2)
            }}
          </span>
          <span v-else>
            {{
              $tc('user.confirmDeleteTip', 1) +
                row.loginName +
                $tc('user.confirmDeleteTip', 2)
            }}
          </span>
        </div>
        <el-row :gutter="20">
          <el-col :span="16">
            <template v-if="isEmail">
              <el-form-item :label="this.$t('company.email')">
                <el-input v-model="codeForm.email" :disabled="true"></el-input>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item :label="this.$t('company.phone')">
                <el-input v-model="codeForm.phone" :disabled="true"></el-input>
              </el-form-item>
            </template>
          </el-col>
          <el-col :span="6" v-if="isChange">
            <el-button
              type="primary"
              @click="changeWay(isEmail)"
              :disabled="!isChange"
              >{{ $t('developer.changeWay') }}</el-button
            >
          </el-col>
          <el-col :span="16">
            <el-form-item :label="this.$t('center.code')" prop="code">
              <el-input v-model="codeForm.code"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <timing
              ref="timing"
              @toGetCode="getEmailCode"
              :status="true"
              :isShow="true"
            >
            </timing>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitResetAndDelete">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import timing from '@/components/timing'
import * as accountApi from '@/services/adminAccountApi.js'
import { verifyCode } from '@/services/acountApi.js'
import { dateFormat, dateByTimestamp } from '@/utils/utils.js'
import { getEmailCode, sendPhoneCode } from '@/services/userCenter.js'

import {
  validatorEmailRule,
  validatorPhoneRule
} from '@/utils/validatorRule.js'
export default {
  components: {
    timing
  },
  data() {
    let _self = this
    let checkRepasswd = (rule, value, callback) => {
      if (!(value + '')) {
        return callback(new Error(this.$t('user.input2ndPwd')))
      } else if (value !== this.userform.password) {
        return callback(new Error(this.$t('user.pwdInconsistent')))
      } else {
        callback()
      }
    }
    let checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('user.selectStatus')))
      } else {
        callback()
      }
    }
    let checkEmail = (rules, value, callback) => {
      if (
        _self.sourceData.email &&
        (value.substr(2, 3) === '***' || value.substr(1, 3) === '***')
      ) {
        if (value !== _self.emailFormat(_self.sourceData.email)) {
          return callback(new Error(window.vm.$t('common.emailValid')))
        }
      }
      return callback()
    }
    let checkPhone = (rules, value, callback) => {
      if (_self.sourceData.phone && value.substr(3, 5) === '*****') {
        if (value !== _self.phoneFormat(_self.sourceData.phone)) {
          return callback(new Error(window.vm.$t('common.phoneValid')))
        }
      }
      callback()
    }
    let checkCode = (rules, value, cb) => {
      if (value) {
        let params = {
          type: 'authentication',
          code: value
        }
        params.loginName = this.isEmail ? this.row.appEmail : this.row.appPhone
        verifyCode(params)
          .then(data => {
            if (data.code === '00000000') {
              return cb()
            } else {
              return cb(new Error(data.message))
            }
          })
          .catch(e => {})
      }
    }
    let rules = {
      loginName: this.validatorInputEmptyRule(true, 30),
      name: this.validatorInputEmptyRule(false, 100),
      password: this.validatorPasswordRule(true),
      secondPwd: [
        { required: true, validator: checkRepasswd, trigger: 'blur' }
      ],
      status: [{ required: true, validator: checkStatus, trigger: 'blur' }],
      email: validatorEmailRule(true, checkEmail),
      phone: validatorPhoneRule(false, checkPhone),
      row: []
    }

    return {
      rules,
      codeRules: {
        code: this.validatorInputEmptyRule(true, 6, checkCode)
      },
      currentRow: null,
      dialogTitle: '',
      dialogFormVisible: false,
      isUpdate: true,
      idDetails: false,
      userData: [],
      params: {
        companyId: '',
        loginName: ''
      },
      userform: {
        loginName: '',
        name: '',
        nickName: '',
        password: '',
        secondPwd: '',
        age: 0,
        sex: 2,
        phone: '',
        email: '',
        status: 1
      },
      codeForm: {
        code: '',
        phone: '',
        email: ''
      },
      dialogVisible: false,
      sourceData: {},
      isReset: false,
      row: {},
      title: '',
      isEmail: false,
      isChange: false
    }
  },
  props: {
    company: {
      type: String,
      default: ''
    },
    queryByCmp: {
      type: Boolean,
      default: false
    },
    isInPage: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    company: {
      handler: function(val, oVal) {
        if (val) {
          this.params.companyId = val
          this.commQuery()
        } else {
          this.params.companyId = ''
          this.userData = []
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.company) {
      this.params.companyId = this.company
    }
    this.commQuery()
  },
  methods: {
    getCodeByType() {
      let params = { type: 'authentication' }
      this.isEmail
        ? (params.email = this.row.appEmail)
        : (params.phone = this.row.appPhone)
      const apiService = [getEmailCode, sendPhoneCode]
      let result = {}
      apiService.forEach(item => {
        result[item] = () =>
          item(params)
            .then(data => {
              data.code === '00000000'
                ? this.$refs.timing.beginTime()
                : this.errorMessage(data.message)
            })
            .catch(e => console.log(e))
      })
      return result
    },
    getEmailCode() {
      let send = this.isEmail
        ? this.getCodeByType()[getEmailCode]
        : this.getCodeByType()[sendPhoneCode]
      send.call(this)
    },
    freezeOrUnfreeze(val, row) {
      if (val) {
        // 启用
        this.unfreeze(row, val)
      } else {
        // 冻结
        this.freeze(row, val)
      }
    },

    initForm() {
      this.userform.loginName = ''
      this.userform.name = ''
      this.userform.nickName = ''
      this.userform.password = ''
      this.userform.secondPwd = ''
      this.userform.age = 0
      this.userform.sex = 2
      this.userform.phone = ''
      this.userform.email = ''
      this.userform.status = 1
    },

    formateTime(createTime) {
      return dateFormat(dateByTimestamp(createTime), null)
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    changePage(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    resetQuery() {
      this.params.loginName = ''
      this.pager.curPage = 0
      this.commQuery()
    },
    commQuery() {
      if (this.queryByCmp && !this.params.companyId) {
        return false
      }
      accountApi
        .queryCompanyUserList({
          params: this.params,
          pager: this.pager
        })
        .then(data => {
          if (data.code === '00000000') {
            this.userData = data.payload.results.results || data.payload.results
            this.pager.curPage =
              data.payload.results.curPage || data.payload.curPage
            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.pager.pageSize =
              data.payload.results.pageSize || data.payload.pageSize
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
    },
    changeWay(val) {
      this.isEmail = !val
      this.$refs.timing.clearTimer()
    },
    handleApi() {
      let params = {
        userId: this.row.id,
        code: this.codeForm.code
      }
      params.loginName = this.isEmail ? this.row.appEmail : this.row.appPhone
      const apiService = [
        accountApi.resetCompanyUserPassword,
        accountApi.deleteCompanyUser
      ]
      let result = {}
      apiService.forEach(item => {
        result[item] = () =>
          item(params)
            .then(data => {
              if (data.code === '00000000') {
                this.dialogVisible = false
                let successMsg = this.isReset
                  ? this.$t('user.successResetPwd')
                  : this.$t('common.successDelete')
                this.successMessage(successMsg)
                this.commQuery()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => this.errorMessage())
      })
      return result
    },
    submitResetAndDelete() {
      this.$refs.codeForm.validate(valid => {
        if (valid) {
          let send = this.isReset
            ? this.handleApi()[accountApi.resetCompanyUserPassword]
            : this.handleApi()[accountApi.deleteCompanyUser]
          send.call(this)
        }
      })
    },
    deleteUser(row) {
      this.isReset = false
      this.handleOperation(row)
    },
    resetPassword(row) {
      this.isReset = true
      this.handleOperation(row)
    },
    handleOperation(row) {
      let msg = this.isReset
        ? this.$t('user.notAllowToResetPwd')
        : this.$t('user.notAllowToRemove')
      if (row.loginName === 'admin') {
        this.errorMessage(msg)
        return false
      }
      if (this.hasPhoneAndEmail(row)) {
        this.row = row
        this.title = this.isReset
          ? this.$t('user.confirmResetPwd')
          : this.$t('common.confirmDelete')
        this.dialogVisible = true
      }
    },

    // notAllowToChange: '超级管理员不允许修改！',
    // notAllowToRemove: '超级管理员不允许删除！',
    // notAllowToResetPwd: '超级管理员不允许重置密码！',
    // notAllowToFreeze: '超级管理员不允许冻结！',
    handleClose() {
      this.dialogVisible = false
      setTimeout(() => {
        if (this.$refs.codeForm) {
          this.$refs.codeForm.resetFields()
        }
        if (this.$refs.timing) {
          this.$refs.timing.clearTimer()
        }
      }, 300)
    },
    hasPhoneAndEmail(row) {
      let r = [undefined, '']
      if (r.includes(row.appPhone) && r.includes(row.appEmail)) {
        this.$message.warning(this.$t('warningOperation.hasPhoneOrEmail'))
        return false
      }
      this.codeForm.phone = this.phoneFormat(row.appPhone) || ''
      this.codeForm.email = this.emailFormat(row.appEmail) || ''
      if (row.appPhone && row.appEmail) {
        this.isChange = true
        this.isEmail = false
      } else if (row.appPhone && this.isEmptyData(row.appEmail)) {
        this.isChange = false
        this.isEmail = false
      } else if (this.isEmptyData(row.appPhone) && row.appEmail) {
        this.isChange = false
        this.isEmail = true
      }
      return true
    },

    addUser() {
      this.dialogTitle = this.$t('user.addUser')
      this.idDetails = false
      this.isUpdate = false
      this.initForm()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.clearValidate()
      })
    },
    setUpdate(row) {
      this.row = row
      this.userform.loginName = row.loginName
      this.userform.name = row.name
      this.userform.nickName = row.nickName
      this.userform.password = row.password
      this.userform.age = row.age
      this.userform.sex = row.sex
      this.userform.phone = this.phoneFormat(row.phone)
      this.userform.email = this.emailFormat(row.email)
      this.userform.status = row.status
      this.sourceData = Object.assign({}, this.userform)
    },
    updateUser(row) {
      if (row.loginName === 'admin') {
        this.$message({
          type: 'error',
          message: this.$t('user.notAllowToChange')
        })
        return false
      }
      this.dialogTitle = this.$t('user.modifyUser')
      this.idDetails = false
      this.isUpdate = true
      this.setUpdate(row)
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.clearValidate()
      })
    },
    clearValidate() {
      this.$refs.formValidate.clearValidate()
    },
    userDetails(row) {
      this.dialogTitle = this.$t('user.userDetail')
      this.idDetails = true
      this.isUpdate = false
      this.setUpdate(row)
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.clearValidate()
      })
    },

    unfreeze(row) {
      this.$confirm(
        this.$tc('user.confirmUnfreezeTip', 1) +
          ' ' +
          row.loginName +
          this.$tc('user.confirmUnfreezeTip', 2),
        this.$t('user.confirmUnfreeze'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          accountApi
            .changeCompanyUserStatus({
              userId: row.id,
              status: 1
            })
            .then(data => {
              if (data.code === '00000000') {
                row.status = 1
                this.$message({
                  type: 'success',
                  message: this.$t('user.successUnfreeze')
                })
                this.commQuery()
              } else {
                row.status = 0
                this.$message({
                  type: 'error',
                  message: data.message
                })
              }
            })
            .catch(data => {
              row.status = 0
              this.$message({
                type: 'error',
                message: data.message
              })
            })
        })
        .catch(() => {
          // 取消
          row.status = 0
          this.$message({
            type: 'info',
            message: this.$t('user.cancelUnfreeze')
          })
        })
    },
    freeze(row) {
      if (row.loginName === 'admin') {
        this.$message({
          type: 'error',
          message: this.$t('user.notAllowToFreeze')
        })
        return false
      }
      this.$confirm(
        this.$tc('user.confirmFreezeTip', 1) +
          ' ' +
          row.loginName +
          this.$tc('user.confirmFreezeTip', 2),
        this.$t('user.confirmFreeze'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          accountApi
            .changeCompanyUserStatus({
              userId: row.id,
              status: 0
            })
            .then(data => {
              if (data.code === '00000000') {
                row.status = 0
                this.$message({
                  type: 'success',
                  message: this.$t('user.successFreeze')
                })
                this.commQuery()
              } else {
                row.status = 1
                this.$message({
                  type: 'error',
                  message: data.message
                })
              }
            })
            .catch(data => {
              row.status = 1
              this.$message({
                type: 'error',
                message: data.message
              })
            })
        })
        .catch(e => {
          row.status = 1
          this.$message({
            type: 'info',
            message: this.$t('user.cancelFreeze')
          })
        })
    },
    submitSave() {
      if (this.idDetails) {
        this.dialogFormVisible = false
        return false
      } else if (this.isUpdate) {
        // 更改
        let params = this.userform
        let temp = Object.assign({}, params)
        if (this.userform.email === this.emailFormat(this.row.email)) {
          temp.email = this.row.email
        } else {
          temp.email = this.userform.email
        }
        if (this.userform.phone === this.phoneFormat(this.row.phone)) {
          temp.phone = this.row.phone
        } else {
          temp.phone = this.userform.phone
        }
        delete temp.password
        delete temp.secondPwd

        if (this.company) {
          temp.companyId = this.company
        }

        this.$refs.formValidate.validate(valid => {
          if (valid) {
            accountApi
              .updateCompanyUser(temp)
              .then(data => {
                this.dialogFormVisible = false
                if (data.code === '00000000') {
                  this.commQuery()
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {
                this.errorMessage()
              })
          }
        })
      } else {
        // 新增
        let params = this.userform
        if (this.company) {
          params.companyId = this.company
        }

        this.$refs.formValidate.validate(valid => {
          if (valid) {
            accountApi
              .addCompanyUser(params)
              .then(data => {
                this.dialogFormVisible = false
                if (data.code === '00000000') {
                  this.commQuery()
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {
                this.errorMessage()
              })
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/var.less';

.search-bar-margin-bottom-cla {
  display: flex;
  .search-from-cla {
    display: flex;
    align-items: start;
  }
}

.inpage_black {
  padding: 0px;
  position: absolute;
  top: -45px;
  right: 5px;
}

.zk_btn_group_cla {
  display: flex;
  justify-content: flex-end;
}
.admin-account-cla-btnGroup {
  display: flex;
  justify-content: flex-start;
}
.addUser-btn-group-cla {
  /deep/ .el-button--small {
    padding: 9px 15px !important;
    cursor: pointer;
  }
}

.adduserFrom {
  /deep/.el-select {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/comComponent/adminAccountManager.vue